import { useState } from 'react'
import './AcademicTimeLine.css'
// import { FaBeer } from 'react-icons/fa';
import { BsArrowRightCircle } from 'react-icons/bs';
import { BsArrowLeftCircle } from 'react-icons/bs';

const AcademictimeLine = () => {
    const [checkID, setCheckID] = useState(3)
    const HeightAcademicCard = 3;

    // const timelineSelectHandle = () => {
    //     set
    // }
    
    return (
      <>
        <div class="academictimelinewrapper">
          <BsArrowLeftCircle
            className="left-arrow-slide"
            onClick={() => {
              if (checkID + 1 > HeightAcademicCard) {
                setCheckID(1);
              } else {
                setCheckID((prev) => prev + 1);
              }
            }}
          />
          <BsArrowRightCircle
            className="right-arrow-slide"
            onClick={() => {
              if (checkID - 1 < 1) {
                setCheckID(HeightAcademicCard);
              } else {
                setCheckID((prev) => prev - 1);
              }
            }}
          />
          <p style={{ fontSize: "1.5vw", textAlign: "center" }}>
            <strong>My Academic timeline</strong>
          </p>
          <br />
          <br />
          {/* <p id="note">Since the flex property only works in Chrome, if your are using other browers please set the $chrome variable to false. <br/> It seems there is a CSS3 transform bug in Safari.</p> */}
          <ul id="timeline">
            <li class="entry">
              {checkID === 3 ? (
                <input
                  checked="checked"
                  class="radio checkedRadio"
                  id="trigger3"
                  name="trigger"
                  type="radio"
                />
              ) : (
                <input
                  class="radio"
                  id="trigger3"
                  name="trigger"
                  type="radio"
                />
              )}
              {/* <input  class='radio' id='trigger5' name='trigger' type='radio'/> */}
              <label for="trigger3" onClick={() => setCheckID(3)}>
                <span>B.Sc.</span>
              </label>
              <span class="academic-date">2019</span>
              {checkID === 3 ? (
                <span className="academic-circle checkedacademic-circle"></span>
              ) : (
                <span className="academic-circle"></span>
              )}

              {/* <span className='academic-circle checkedacademic-circle'></span> */}
              <div class="academic-content">
                <br />
                <h4 style={{ textAlign: "center", fontSize: "1.5vw" }}>
                  Bachelor of Science (B.Sc.) [2015-2019]
                </h4>
                <p className="academic-content-text">
                  Institute: <strong>East West University.</strong>
                  <br />
                  <br />
                  Session: 2015-2019
                  <br />
                  Passing Year: 2019
                  <br />
                  CGPA: 3.68 (out of 4.00)
                </p>
                <div>
                  <a
                    href="https://drive.google.com/drive/folders/1k-XWHbw65ZO9jnVJXgVv-v57LRkwXCYH?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="transcript-btn"
                  >
                    {/* <p className='view-transcript-btn-text'>View Transcript</p>  */}
                    View Transcript
                  </a>
                </div>
              </div>
            </li>
            <li class="entry">
              {checkID === 2 ? (
                <input
                  checked="checked"
                  class="radio checkedRadio"
                  id="trigger2"
                  name="trigger"
                  type="radio"
                />
              ) : (
                <input
                  class="radio"
                  id="trigger2"
                  name="trigger"
                  type="radio"
                />
              )}
              {/* <input  class='radio' id='trigger5' name='trigger' type='radio'/> */}
              <label for="trigger2" onClick={() => setCheckID(2)}>
                <span>HSC</span>
              </label>
              <span class="academic-date">2013</span>
              {checkID === 2 ? (
                <span className="academic-circle checkedacademic-circle"></span>
              ) : (
                <span className="academic-circle"></span>
              )}

              {/* <span className='academic-circle checkedacademic-circle'></span> */}
              <div class="academic-content">
                <br />
                <h4 style={{ textAlign: "center", fontSize: "1.5vw" }}>
                  Higher Secondary Certificate (HSC) [2011-2012]
                </h4>
                <p className="academic-content-text">
                  Institute: <strong>St. Joseph Higher Secondary School</strong>
                  <br />
                  <br />
                  Session: 2011-2012
                  <br />
                  Passing Year: 2013
                  <br />
                  GPA: 5.00 (A+)
                </p>
                <div>
                  <a
                    href="https://drive.google.com/drive/folders/1g0CdH0IUD-fF5HMgx0RwRa4mbO6pBJPJ?usp=sharing"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="transcript-btn"
                  >
                    {/* <p className='view-transcript-btn-text'>View Transcript</p>  */}
                    View Transcript
                  </a>
                </div>
              </div>
            </li>
            <li class="entry">
              {checkID === 1 ? (
                <input
                  checked="checked"
                  class="radio checkedRadio"
                  id="trigger1"
                  name="trigger"
                  type="radio"
                />
              ) : (
                <input
                  class="radio"
                  id="trigger1"
                  name="trigger"
                  type="radio"
                />
              )}
              {/* <input  class='radio' id='trigger5' name='trigger' type='radio'/> */}
              <label for="trigger1" onClick={() => setCheckID(1)}>
                <span>SSC</span>
              </label>
              <span class="academic-date">2011</span>
              {checkID === 1 ? (
                <span className="academic-circle checkedacademic-circle"></span>
              ) : (
                <span className="academic-circle"></span>
              )}

              {/* <span className='academic-circle checkedacademic-circle'></span> */}
              <div class="academic-content">
                <br />
                <h4 style={{ textAlign: "center", fontSize: "1.5vw" }}>
                  Secondary School Certificate (SSC) [2009-2010]
                </h4>
                <p className="academic-content-text">
                  Institute:{" "}
                  <strong>Bandda Alatunnesa Higher Secondary School.</strong>
                  <br />
                  <br />
                  Session: 2009-2010
                  <br />
                  Passing Year: 2011
                  <br />
                  GPA: 5.00 (Golden A+)
                </p>
                <div>
                  <a
                    href="https://drive.google.com/drive/folders/1WmetDCUsD468e7lE6nK3FgjHKnUDVVzX?usp=sharing"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="transcript-btn"
                  >
                    {/* <p className='view-transcript-btn-text'>View Transcript</p>  */}
                    View Transcript
                  </a>
                </div>
              </div>
            </li>
            {/* <li class='entry'>
    <input class='radio' id='trigger2' name='trigger' type='radio'/>
    <label for='trigger2'>
      <span>
        Lorem ipsum dolor sit amet
      </span>
    </label>
    <span class='academic-date'>13 May 2013</span>
    <span class='academic-circle'></span>
    <div class='academic-content'>
      <h3>Lorem ipsum dolor sit amet (13 May 2013)</h3>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt!
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
      </p>
    </div>
  </li>
  <li class='entry'>
    <input class='radio' id='trigger1' name='trigger' type='radio'/>
    <label for='trigger1'>
      <span>
        Lorem ipsum dolor sit amet
      </span>
    </label>
    <span class='academic-date'>12 May 2013</span>
    <span class='academic-circle'></span>
    <div class='academic-content'>
      <h3>Lorem ipsum dolor sit amet (12 May 2013)</h3>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt!
      </p>
    </div>
  </li> */}
          </ul>
        </div>
      </>
    );

}

export default AcademictimeLine;